import styled from 'styled-components'

const variantColors = {
  operational:          { bg: 'var(--vo-success-10)',  text: 'var(--vo-success)' },
  active:               { bg: 'var(--vo-success-10)',  text: 'var(--vo-success)' },
  published:            { bg: 'var(--vo-success-10)',  text: 'var(--vo-success)' },
  success:              { bg: 'var(--vo-success-10)',  text: 'var(--vo-success)' },
  warning:              { bg: 'var(--vo-warning-10)',  text: 'var(--vo-warning)' },
  pending:              { bg: 'var(--vo-warning-10)',  text: 'var(--vo-warning)' },
  error:                { bg: 'var(--vo-danger-10)',   text: 'var(--vo-danger)' },
  inactive:             { bg: 'var(--vo-danger-10)',   text: 'var(--vo-danger)' },
  info:                 { bg: 'var(--vo-info-10)',     text: 'var(--vo-info)' },
  secondary:            { bg: 'var(--vo-info-10)',     text: 'var(--color-brand-strong)' },
  draft:                { bg: `var(--vo-slate-10)`,     text: 'var(--vo-ink-2)' },
  archived:             { bg: `var(--vo-slate-10)`,     text: 'var(--vo-ink-2)' },
  'maturity-initial':   { bg: 'var(--vo-danger-10)',  text: 'var(--vo-danger)' },
  'maturity-developing':{ bg: 'var(--vo-warning-10)', text: 'var(--vo-warning)' },
  'maturity-defined':   { bg: `color-mix(in srgb, var(--vo-capri) 10%, transparent)`,     text: 'var(--vo-capri)' },
  'maturity-managed':   { bg: 'var(--vo-info-10)',    text: 'var(--vo-celeste)' },
  'maturity-optimized': { bg: 'var(--vo-success-10)', text: 'var(--vo-success)' },
  public:               { bg: 'var(--vo-success-10)',  text: 'var(--vo-success)' },
  protected:            { bg: 'var(--vo-warning-10)',  text: 'var(--vo-warning)' },
  private:              { bg: 'var(--vo-danger-10)',   text: 'var(--vo-danger)' },
  primary:              { bg: 'var(--color-brand-30)',  text: 'var(--color-brand)' },
  tier1:                { bg: 'var(--vo-info-10)',     text: 'var(--vo-cobalto)' },
  tier2:                { bg: `color-mix(in srgb, var(--vo-capri) 10%, transparent)`,      text: 'var(--vo-capri)' },
  tier3:                { bg: 'var(--vo-success-10)',  text: 'var(--vo-success)' },
  default:              { bg: 'var(--vo-mist)',          text: 'var(--vo-slate)' },
}

const fallbackColor = { bg: 'var(--vo-mist)', text: 'var(--vo-slate)' }

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: var(--radius-xl);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  background-color: ${({ $variant }) =>
    variantColors[$variant]?.bg || fallbackColor.bg};
  color: ${({ $variant }) =>
    variantColors[$variant]?.text || fallbackColor.text};
`
